export const LOAD_PROGRAMS = 'LOAD_PROGRAMS'
export const ADD_PROGRAM = 'ADD_PROGRAM'
export const SET_CURRENT_PROGRAM = 'SET_CURRENT_PROGRAM'
export const UPDATE_PROGRAM = 'UPDATE_PROGRAM'
export const REMOVE_PROGRAM = 'REMOVE_PROGRAM'
export const LOAD_EARNING_TYPES = 'LOAD_EARNING_TYPES'
export const LOAD_REWARD_TYPES = 'LOAD_REWARD_TYPES'
export const LOAD_MY_SHOPS = 'LOAD_MY_SHOPS'
export const LOAD_SIMPLE_PRODUCTS = 'LOAD_SIMPLE_PRODUCTS'
export const SET_POS_MEMBERSHIP = 'SET_POS_MEMBERSHIP'
export const CLEAR_POS_MEMBERSHIP = 'CLEAR_POS_MEMBERSHIP'
export const LOAD_MEMBERS = 'LOAD_MEMBERS'
export const SET_CURRENT_MEMBER = 'SET_CURRENT_MEMBER'
